settingMapModule = angular.module('map.setting', [])

settingMapModule.directive "mapSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", "MapInit", ($window, $timeout, $compile, $templateCache, ns, MapInit) ->
  restrict: "A",
  templateUrl: "#{settingFolder}/map/template.jade",
  scope: {data: "=ngModel"},
  link: (scope, element, attrs, ngModel) ->
    widgetEl = angular.element("[data-block-id='#{attrs.widgetId}']")
    mapProvider = scope.data.provider

    map = undefined
    marker = undefined
    geocoder = undefined
    infowindow = undefined
    bounds = undefined

    # gId
    # gDocs https://developers.google.com/maps/documentation/javascript/
    # AIzaSyAgmfwMdrulBT6TxzPC46mO2O8miHEkhvw

    # apply css

    listener1 = scope.$watch "data.style_attributes.height", (newVal, oldVal) ->
      mapWrapper = widgetEl.find(".str-map__wrapper")
      mapWrapper.css "height", newVal


    # change map type

    listener2 = scope.$watch "data.provider", (newVal, oldVal) ->
      if newVal is oldVal
        result = widgetEl[0]["#{newVal}Map"]
      else
        result = MapInit.initMap 0, widgetEl.find(".strw__map"), scope.data

      if newVal is "google"
        map = result.map_instance
        marker = result.marker
        geocoder = result.geocoder
        infowindow = result.infowindow

        # listeners

        map.addListener 'zoom_changed', ->
          scope.data.zoom = map.getZoom()
        google.maps.event.addListener marker,'dragend', (event) ->
          scope.data.lat = event.latLng.lat();
          scope.data.lon = event.latLng.lng();

      if newVal is "yandex"
        map = result.map_instance
        marker = result.marker

        # listeners

        map.events.add 'boundschange', (e) ->
          newZoom = e.get 'newZoom'
          oldZoom = e.get 'oldZoom'
          if newZoom != oldZoom
            scope.data.zoom = newZoom
        marker.events.add 'dragend', (e) ->
          scope.data.lat = marker.geometry.getCoordinates()[0]
          scope.data.lon = marker.geometry.getCoordinates()[1]

    # change map pin text

    listener3 = scope.$watch "data.pin_text", (newVal, oldVal) ->
      updatePinText()

    # destroy scopes on exit

    scope.$on "destroy", ->
      listener1()
      listener2()
      listener3()

    # update map pin text

    updatePinText = ->
      if scope.data.provider is "google" and infowindow
        infowindow.setContent scope.data.pin_text
      if scope.data.provider is "yandex"
        marker.properties.set 'balloonContent', scope.data.pin_text

    # geocoder (yandex,google)

    scope.searchGeo = ->
      currentProvider = scope.data.provider
      providersSearchMethods[currentProvider]()

    # google fit

    fitToMarkers = (markers) ->
      bounds = new (google.maps.LatLngBounds)
      for index of markers
        latlng = markers[index].getPosition()
        bounds.extend latlng
      if bounds.getNorthEast().equals(bounds.getSouthWest())
        extendPoint1 = new (google.maps.LatLng)(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01)
        extendPoint2 = new (google.maps.LatLng)(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01)
        bounds.extend extendPoint1
        bounds.extend extendPoint2
      map.fitBounds bounds
      return

    # google search

    googleSearchGeo = ->
      address = scope.data.address
      geocoder.geocode { 'address': address }, (results, status) ->
        if status is google.maps.GeocoderStatus.OK
          location = results[0].geometry.location
          marker.setPosition location
          fitToMarkers [marker]
          scope.data.lat = location.lat()
          scope.data.lon = location.lng()

    # yandex search

    yandexSearchGeo = ->
      myGeocoder = ymaps.geocode scope.data.address
      myGeocoder.then (res) ->
        coords = res.geoObjects.get(0).geometry.getCoordinates()
        map.setCenter coords
        bounds = res.geoObjects.get(0).properties.get('boundedBy');
        map.setBounds bounds
        marker.geometry.setCoordinates coords
        scope.data.lat = coords[0]
        scope.data.lon = coords[1]
      return

    # search methods

    providersSearchMethods =
      google: googleSearchGeo
      yandex: yandexSearchGeo
]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/map/map.directive.coffee